import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import * as PIXI from "pixi.js-legacy";
import { useSelector } from "react-redux";
import { GAME_STATUS } from "../../store/features/status";
import { getBgColor } from "../../services/Helpers/RadialGradient";
import RetailRoundIdSoaring from "../Retail/RetailRoundIdSoaring";
import RetailBonusRound from "../Retail/RetailBonusRound";

const backgroundSVG = "data:image/svg+xml;base64,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";
const ANIMATION_DURATION = 5000; // ms
const FLYOUT_DURATION = 500;

const Soaring = () => {
  const gameplay = useSelector((state) => state.gameplay);
  const status = useSelector((state) => state.status);

  const containerRef = useRef(null);
  const canvasRef = useRef(null);
  const appRef = useRef(null);

  const spriteRef = useRef(null);
  const backgroundRef = useRef(null);
  const graphicsRef = useRef(null);

  const rocketRotationAngleRef = useRef(0);
  const rotationTickerRef = useRef(null);

  const [size, setSize] = useState({ width: 0, height: 0 });
  const [animationStarted, setAnimationStarted] = useState(false);
  const [finished, setFinished] = useState(false);
  const [flyOutStarted, setFlyOutStarted] = useState(false);
  const [oldMultiplier, setOldMultiplier] = useState(0);
  const lastStatusRef = useRef(null);

  const progressRef = useRef(0);
  const oscillationTicker = useRef(null);

  // Ne-render state
  const rocketPosRef = useRef({ x: 0, y: 0 });
  const hasValidLayoutRef = useRef(false);

  const drawPath = useCallback(() => {
    if (flyOutStarted || finished) return;
    if (!hasValidLayoutRef.current || !size.height) return;

    const g = graphicsRef.current;
    if (!g) return;

    const { x, y } = rocketPosRef.current;

    g.clear();
    g.lineStyle(5, PIXI.utils.string2hex("#FF003D"), 0.68);

    // Start uvek odozdo-levo (malo van ekrana kao ranije)
    const startX = -20;
    const startY = size.height;

    g.moveTo(startX, startY);

    const steps = 30;
    const exponent = 4;

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const xx = startX + (x - startX) * t;
      const yy = startY + (y - startY) * Math.pow(t, exponent);
      g.lineTo(xx, yy);
    }

    // Ispuna ispod krive
    g.lineStyle(0);
    g.beginFill(PIXI.utils.string2hex("#8F0D2E"), 0.41);
    g.moveTo(startX, startY);
    g.lineTo(x, startY);

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const xx = startX + (x - startX) * t;
      const yy = startY + (y - startY) * Math.pow(t, exponent);
      g.lineTo(xx, yy);
    }

    g.lineTo(x, startY);
    g.lineTo(startX, startY);
    g.endFill();
  }, [size.height, flyOutStarted, finished]);

  const setRocket = useCallback(
    (x, y) => {
      if (!hasValidLayoutRef.current || !size.height) return; // dok nema visine, ne diraj
      rocketPosRef.current.x = x;
      rocketPosRef.current.y = y;
      if (spriteRef.current) {
        spriteRef.current.x = x;
        spriteRef.current.y = y;
        spriteRef.current.rotation = rocketRotationAngleRef.current;
      }
      drawPath();
    },
    [drawPath, size.height]
  );

  // const getMpClass = (mp) => {
  //   const value = Number(mp);
  //   if (value > 0.99 && value <= 1.99) return "light-blue";
  //   if (value > 1.99 && value <= 4.99) return "blue";
  //   if (value > 4.99 && value <= 9.99) return "green";
  //   if (value > 9.99 && value <= 49.99) return "yellow";
  //   if (value > 49.99 && value <= 99.99) return "orange";
  //   if (value > 99.99) return "red";
  //   return "win-small";
  // };

  useEffect(() => {
    const canvas = canvasRef.current;
    const app = new PIXI.Application({
      view: canvas,
      resizeTo: containerRef.current || window,
      backgroundAlpha: 0,
      preserveDrawingBuffer: false, // performanse na RPi3
      //resolution: 0.8,    
      autoDensity: false // zadrži 1:1, CSS neka skalira
    });
    app.stage.sortableChildren = true;
    appRef.current = app;

    PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
    PIXI.settings.ROUND_PIXELS = true;
    spriteRef.current && (spriteRef.current.roundPixels = true);

    const bg = new PIXI.Sprite(PIXI.Texture.from(backgroundSVG));
    backgroundRef.current = bg;
    bg.anchor.set(0.5);
    bg.alpha = 0.5;
    bg.zIndex = -1;
    app.stage.addChild(bg);

    const gfx = new PIXI.Graphics();
    graphicsRef.current = gfx;
    gfx.zIndex = 0;
    app.stage.addChild(gfx);

    const rocket = new PIXI.Sprite(PIXI.Texture.from("tex/glider.png"));
    rocket.width = 170;
    rocket.height = 170;
    rocket.anchor.set(0.5);
    rocket.zIndex = 1;
    spriteRef.current = rocket;
    app.stage.addChild(rocket);

    const updateSize = () => {
      if (!containerRef.current) return;
      const { clientWidth, clientHeight } = containerRef.current;
      setSize({ width: clientWidth, height: clientHeight });

      if (clientHeight > 0) {
        // tek sad možemo da crtamo
        hasValidLayoutRef.current = true;

        const p = progressRef.current || 0;
        const easedYProgress = Math.pow(p, 2);

        if (status === GAME_STATUS.IDLE) {
          setRocket(38, clientHeight - 20);
        } else {
          setRocket(
            p * clientWidth + clientWidth * 0.1,
            clientHeight - easedYProgress * clientHeight * 0.9
          );
        }
      }
    };

    updateSize();
    const observer = new ResizeObserver(updateSize);
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      observer.disconnect();
      oscillationTicker.current?.stop();
      rotationTickerRef.current?.stop?.();
      rotationTickerRef.current?.destroy?.();
      app.destroy(true, { children: true });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  useEffect(() => {
    if (!animationStarted || size.width === 0 || !hasValidLayoutRef.current)
      return;

    const startTime = Date.now() - progressRef.current * ANIMATION_DURATION;
    const duration = ANIMATION_DURATION;
    const ticker = PIXI.Ticker.shared;
    const startX = rocketPosRef.current.x;
    const startY = rocketPosRef.current.y;
    const endX = size.width * 0.87;

    const animationFrame = () => {
      const elapsedTime = Date.now() - startTime;
      let progress = Math.min(elapsedTime / duration, 1);
      if (status === GAME_STATUS.ENDING) progress = 1;
      progressRef.current = progress;

      const easedProgress = easeOutCubic(progress);
      const newX = startX + (endX - startX) * easedProgress;
      const newY =
        startY - Math.pow(easedProgress, 2) * (startY - size.height * 0.15);

      setRocket(newX, newY);

      if (progress === 1) {
        ticker.remove(animationFrame);
        startOscillation(newX, newY);
      }
    };

    ticker.add(animationFrame);

    return () => {
      ticker.remove(animationFrame);
      oscillationTicker.current?.stop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationStarted, size.width, size.height, status, setRocket]);

  const startOscillation = useCallback(
    (finalX, finalY) => {
      oscillationTicker.current?.stop();
      oscillationTicker.current?.destroy();
      oscillationTicker.current = new PIXI.Ticker();

      oscillationTicker.current.add(() => {
        if (!hasValidLayoutRef.current) return;
        const time = (Date.now() % 2000) / 2000;
        const amplitude = 6;
        const offsetY = Math.sin(time * Math.PI * 2) * amplitude;
        setRocket(finalX, finalY + offsetY);
      });

      oscillationTicker.current.start();
    },
    [setRocket]
  );

  useEffect(() => {
    if (status === GAME_STATUS.ENDING) {
      setFlyOutStarted(true);
      graphicsRef.current?.clear();
    } else {
      setFlyOutStarted(false);
    }
  }, [status]);

  useEffect(() => {
    const rocket = spriteRef.current;
    const app = appRef.current;
    if (!rocket || !app) return;

    if (finished) {
      app.stage.removeChild(rocket);
    } else if (!app.stage.children.includes(rocket)) {
      rocket.zIndex = 1;
      app.stage.addChild(rocket);
    }
  }, [finished]);

  useEffect(() => {
    if (!flyOutStarted || size.width === 0 || !hasValidLayoutRef.current) return;

    const duration = FLYOUT_DURATION;
    const startX = rocketPosRef.current.x;
    const startY = rocketPosRef.current.y;
    const endX = size.width + 200;
    const endY = startY - size.height * 0.5;
    const startTime = Date.now();
    const ticker = PIXI.Ticker.shared;

    const flyOutFrame = () => {
      if (status === GAME_STATUS.IDLE) return;

      const elapsed = Date.now() - startTime;
      let progress = Math.min(elapsed / duration, 1);
      progress = progress * progress;

      const newX = startX + (endX - startX) * progress;
      const newY = startY + (endY - startY) * progress;

      setRocket(newX, newY);

      if (progress === 1) {
        ticker.remove(flyOutFrame);
        setFinished(true);
      }
    };

    ticker.add(flyOutFrame);
    return () => ticker.remove(flyOutFrame);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flyOutStarted, size.width, size.height, status, setRocket]);

  useEffect(() => {
    if (!gameplay.data?.mp || gameplay.data.mp <= 1 || gameplay.data.end) return;

    const t = new PIXI.Ticker();
    rotationTickerRef.current = t;

    const bgRotSpeed = 0.001;
    const rocketRotSpeed = 0.0001;

    t.add(() => {
      rocketRotationAngleRef.current =
        (rocketRotationAngleRef.current + rocketRotSpeed) % (Math.PI * 2);
      if (spriteRef.current) {
        spriteRef.current.rotation = rocketRotationAngleRef.current;
      }
      if (backgroundRef.current) {
        backgroundRef.current.rotation =
          (backgroundRef.current.rotation + bgRotSpeed) % (Math.PI * 2);
      }
    });

    t.start();

    return () => {
      t.stop();
      t.destroy();
      rotationTickerRef.current = null;
    };
  }, [gameplay.data]);

  useEffect(() => {
    if (!hasValidLayoutRef.current) return;

    if (status === GAME_STATUS.IDLE) {
      setAnimationStarted(false);
      setFinished(false);
      setFlyOutStarted(false);
      progressRef.current = 0;
      oscillationTicker.current?.stop();
      setRocket(38, (size.height || 0) - 20);
    }

    if (status === GAME_STATUS.FLY) {
      setAnimationStarted(false);
      setFinished(false);
      setFlyOutStarted(false);
      progressRef.current = 0;
      oscillationTicker.current?.stop();
      setRocket(38, size.height - 20);
      setTimeout(() => setAnimationStarted(true), 0);
    }
  }, [status, size.height, setRocket]);

  const svgScale = useMemo(() => {
    const baseScale = 2;
    const baseDiagonal = 2760;
    const canvasDiagonal = Math.sqrt(size.width ** 2 + size.height ** 2);
    return (canvasDiagonal / baseDiagonal) * baseScale;
  }, [size]);

  useEffect(() => {
    if (backgroundRef.current) {
      backgroundRef.current.scale.set(svgScale);
      backgroundRef.current.x = 0;
      backgroundRef.current.y = size.height;
    }
  }, [svgScale, size.height]);

  useEffect(() => {
    if (status === GAME_STATUS.IDLE && size.height > 0) {
      hasValidLayoutRef.current = true;
      setRocket(38, size.height - 20);
    }
  }, [size.height, status, setRocket]);

  useEffect(() => {
  if (!containerRef.current) return;

  let bgColor;

  if (gameplay?.data?.bonus) {
    // Bonus runda: ljubičasta → crvena
    bgColor = "linear-gradient(135deg, #A040FF, #FF4040)";
  } else if (gameplay.data?.mp != null) {
    // Obična multiplikatorska boja
    bgColor = getBgColor(gameplay.data.mp);
  }

  containerRef.current.style.setProperty("--dynamic-bg", bgColor);
}, [gameplay?.data?.bonus, gameplay.data?.mp]);


  useEffect(() => {
    if (!gameplay?.data) return;

    if (status === GAME_STATUS.ENDING && lastStatusRef.current !== GAME_STATUS.ENDING) {
      const rawMp = gameplay.data.mp ?? 1.0;
      const formattedMp = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false,
      }).format(rawMp);
      setOldMultiplier(formattedMp);
    }
    lastStatusRef.current = status;
  }, [status, gameplay?.data?.mp]);

  useEffect(() => {
  if (status === GAME_STATUS.ENDING || finished) {
    rocketRotationAngleRef.current = 0;
    if (spriteRef.current) spriteRef.current.rotation = 0;
  }
}, [status, finished]);

  const classNames = [
    "gameplay-container",
    status === GAME_STATUS.FLY && "gameplay__pulse",
  ].filter(Boolean).join(" ");

  return (
    <div ref={containerRef} className={classNames}>
      <RetailRoundIdSoaring status={status}/>
      {status === GAME_STATUS.FLY ? (
        <>
          <div className="gameplay__dots gameplay__dots--horizontal" />
          <div className="gameplay__dots gameplay__dots--vertical" />
        </>
      ) : null}
      <canvas ref={canvasRef} className="gameplay-canvas" />

      {gameplay?.data?.bonus && <RetailBonusRound />}

      {status === GAME_STATUS.FLY ? (
        <p className="gameplay__counter">
          {gameplay?.data?.mp != null
            ? `${new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(gameplay.data.mp)}x`
            : null}
        </p>
      ) : null}
      {status === GAME_STATUS.ENDING ? (
        <p className={`gameplay__counter red`} style={{ position: "relative" }}>
          {oldMultiplier}x
        </p>
      ) : null}
    </div>
  );
};

export default Soaring;
